import React from "react";
import "./LearnMoreSectionOne.css";
import ReactHtmlParser from "react-html-parser";

export default function LearnMoreSectionOne(props) {
  return (
    <>
      <div className="investmentStrategycontainer">
        <p className="investmentStrategytitleTxt">{props?.title}</p>
        <div className="investmentStrategyboxContainer">
          {ReactHtmlParser(props?.data)}
        </div>
      </div>
    </>
  );
}
